<template>
  <DModal :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="$emit('close')">
    <div class="d-modal" slot="insertComponent">
      <div class="d-modal__header">
        <h2>{{ $t('vue2.create_activity.create_new_subject_for') }} {{ user.name }}</h2>
      </div>
      <div class="d-modal__content">
        <div class="d-group">
          <label class="d-label">{{ $t('vue2.create_activity.title') }}</label>
          <input class="d-input" style="height: 34px" v-model="subjectName" id="d-title-input-for-new-subject"
                 ref="d_title_input">
        </div>
        <div class="d-group">
          <label class="d-label">{{ $t('vue2.create_activity.choose_subject_type') }}</label>
          <SubjectFormSubjectType
            :calendarType="'user'"
            @change="setSubjectType">
          </SubjectFormSubjectType>
        </div>
        <div class="d-group" v-if="!isLoadingUserSchools && isUserHasMultipleSchools">
          <label class="d-label">{{ $t('vue2.common.choose_school') }}</label>
          <select v-model="theActiveSchoolId" class="d-select-with-options">
            <option v-for="school in userSchools" :value="school.id" :key="school.id">
              {{ school.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="d-modal__buttons pad-1">
        <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
        <button class="do-bttn do-bttn--submit do-bttn--submit--disabled" v-if="!isValidated">{{
            $t('vue2.common.save')
          }}
        </button>
        <button class="do-bttn do-bttn--submit" v-else
                :class="{'do-bttn--submit--loading': isSubmitting}"
                @click="submit">{{ $t('vue2.common.save') }}
        </button>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal'
import dSelect from '../../DSelect/DSelect.vue'
import moment from 'moment'
import SubjectFormSubjectType from '../../Subjects/SubjectFormSubjectType.vue'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'

export default {
  components: {SubjectFormSubjectType, dSelect, DModal},
  props: {
    title: {
      type: String
    },
    user: {
      type: Object,
      default: () => {
        return {
          name: 'Henrik',
          user_calendar_id: 7
        }
      }
    },
    date: {
      type: Object,
      default: () => moment()
    }
  },
  data () {
    return {
      subjectName: '',
      subjectType: '',
      isSubmitting: false,
      theActiveSchoolId: null,
      userSchools: [],
      isLoadingUserSchools: false
    }
  },
  computed: {
    isValidated () {
      return this.subjectName.length > 0
    },
    activeSchoolYears () {
      return this.$store.state.activeSchoolYears
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    isUserHasMultipleSchools () {
      return Object.keys(this.userSchools).length > 1
    }
  },
  methods: {
    setSubjectType (str) {
      this.subjectType = str
    },
    findSchoolYearId () {
      if (this.activeSchoolYears.length === 1) {
        return this.activeSchoolYears[0].id
      }
      const givenDate = moment(this.date)
      // Filtrer skoleår, der overlapper den givne dato
      const overlappingSchoolYears = this.activeSchoolYears.filter(year => {
        const start = moment(year.employee_time_start)
        const end = moment(year.employee_time_end)
        return givenDate.isBetween(start, end, undefined, '[]') // '[]' betyder inklusiv start- og slutdato
      })

      // Hvis der er flere overlappende skoleår, find den med den seneste employee_time_end
      if (overlappingSchoolYears.length > 0) {
        const latestSchoolYear = overlappingSchoolYears.reduce((latest, current) => {
          const latestEnd = moment(latest.employee_time_end)
          const currentEnd = moment(current.employee_time_end)
          return currentEnd.isAfter(latestEnd) ? current : latest
        }, overlappingSchoolYears[0])

        return latestSchoolYear.id
      } else {
        eventbus.toast = {text: this.$t('vue2.create_activity.the_selected_date_is_outside_schoolyears'), 'success': false}
        return null // Eller en passende værdi, hvis der ikke findes et skoleår
      }
    },
    submit () {
      const calendarId = this.user.user_calendar_id
      const schoolYearId = this.findSchoolYearId()
      if (!schoolYearId) {
        return
      }
      const schoolId = this.theActiveSchoolId
      const color = '#999999'
      const duration = 45
      const preparation = null
      const calendarIds = []
      const subjectCode = null
      this.isSubmitting = true
      docendo.createSubject(this.subjectName, color, calendarId, duration, preparation, 0, this.subjectType, schoolId, schoolYearId, calendarIds, subjectCode, false, null, null, null, data => {
        if (data && data.status === 'error') {
          eventbus.toast = {text: data.message, 'success': false}
          return
        }
        this.$emit('newSubject', data)
      }, failure => {
        console.log('failed')
      })
    },
    readUser () {
      // To get schools
      docendo.showUser(this.user.id, data => {
        this.userSchools = data && data.schools ? data.schools.sort((a, b) => {
          return a.name.localeCompare(b.name)
        }) : []
      }, failure => {

      })
    }
  },
  mounted () {
    this.readUser()
    this.subjectName = this.title
    this.theActiveSchoolId = this.activeSchool.id
    this.$nextTick(_ => {
      const el = this.$refs.d_title_input
      if (el) {
        this.$refs.d_title_input.click()
        this.$refs.d_title_input.focus()
      }
    })
  }
}
</script>

<style scoped>
.d-modal {
  width: 550px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
}

.d-modal__close {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 16px !important;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  background: #fff;
  margin: 0;
  padding: 1rem;
  border-top: 1px solid #d8d8d8;
  border-radius: 0 0 4px 4px;
}

.d-modal__content {
  padding: 1rem;
  max-height: calc(100vh - (2rem + 52px + 53px));
  overflow-y: auto;
  overscroll-behavior: contain;
}

.d-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.d-select-with-options {
  border: 1px solid #ccc;
  background: white;
  color: #3e4450;
  user-select: none;
  height: 26px;
  font-size: 11px;
  font-weight: bold;
  border-radius: 3px;
}

</style>



// WEBPACK FOOTER //
// CreateEventNewSubject.vue?63c5b7fc